/* eslint-disable vue/no-reserved-keys */
<template lang="html">
  <div class="content-item" @click="goRedirectDetails">
    <img class="avater" v-if="user.avatar" v-lazy="`${user.avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`" />
    <img class="avater" v-else src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/default-profile.png?x-oss-process=image/resize,m_fill,w_72,h_72"/>
    <div class="content-item-body">
      <div class="content-item-body-header">
       <span class="content-item-body-header-h2">{{user.nickName}}</span>
       <span v-if="files && files.type"  class="tag"># {{files.type}}</span>
       <div v-else>
          <span v-for="tag of tags" :key="tag.id" class="tag"># {{tag.title}}</span>
       </div>
      </div>
      <span class="desc" v-html="content"></span>
      <div v-if="files" class="files">
        <img src="../../assets/images/activity/file.svg"/>
        <div>
          <a :href="files.file" :download="files.title">
            <label class="files-title">{{files.title}}</label>
          </a>
        </div>
      </div>
      <div class="content-bottom">
        <div class="content-bottom-left">
          <h5>{{getShowTime(crateTime)}}</h5>
          <span v-if="(users && users.id === user.id)" class="delete" @click.stop="deleteMessage">删除</span>
        </div>
        <div class="menus">
          <ThumbUpItem @click="goDetails">
            <img  src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/message-grey.svg" />
            <span>{{commentCount ? commentCount : ''}}</span>
          </ThumbUpItem>
          <ThumbUpItem @click="thumbsUp" v-bind="getThumbUp" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { post, _delete } from '../../utils/request'
import { get, set, remove } from '../../utils/token'
import { getBeforeTimeStr } from '../../utils/date'
import ThumbUpItem from '../../components/thunmbUpItem'
import { Toast } from 'vant'
export default {
  components: {
    ThumbUpItem
  },
  props: {
    id: {
      // type: Number,
      default: 0
    },
    user: {
      type: Object,
      default: () => {
        return {
          avatar: '',
          nickName: '',
          id: ''
        }
      }
    },
    crateTime: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      default: () => {
        return []
      }
    },
    commentCount: {
      type: Number,
      default: 0
    },
    upCount: {
      type: Number,
      default: 0
    },
    isUp: {
      type: Boolean,
      default: false
    },
    files: {
      type: Object,
      default: null
    },
    tags: {
      type: Array,
      default: () => {
        return [
        ]
      }
    }
  },
  data () {
    return {
      initialIndex: 0,
      users: get('user')
    }
  },
  mounted () {
    this.scrollLocation()
  },
  methods: {
    deleteMessage () {
      const promise = _delete({
        url: `/circle/circle?id=${this.id}`
      })
      promise.then(res => {
        const { data: { message } } = res
        this.$emit('deleteMessage', this.id)
        Toast.success(message)
      })
    },
    scrollLocation () {
      this.$nextTick(() => {
        const scrollTop = get('scrollDynamic')
        if (scrollTop && this.$refs.dynamic) {
          this.$refs.dynamic.scrollTop = scrollTop
          remove('scrollDynamic')
        }
      })
    },
    getShowTime (time) {
      return getBeforeTimeStr(time)
    },
    goCreate () {
      const dynamic = this.$parent.$refs.dynamic
      if (dynamic) {
        set('scrollDynamic', this.$parent.$refs.dynamic.scrollTop)
      }
      this.$router.push(`/activity/create?circleId=${this.id}`)
    },
    thumbsUp (callback) {
      const promsie = post({
        url: `/circle/isUp/${this.id}/${get('user').id}`,
        data: {
          isUp: !this.isUp
        }
      })
      promsie.then(res => {
        const { status } = res
        if (Object.is(status, 200)) {
          if (callback) {
            callback()
          }
          this.$emit('thumbsUp')
        }
      })
    },
    goRedirectDetails () {
      // this.$router.push(`/exerland/dynamicTetail/${this.id}`)
    },
    goDetails () {
      const path = this.$route.path
      if (path.indexOf('dynamicTetail') !== -1) {
        this.$router.push(`/activity/create?circleId=${this.id}`)
        return
      }
      if (this.commentCount) {
        this.$router.push(`/exerland/dynamicTetail/${this.id}`)
      } else {
        this.$router.push(`/activity/create?circleId=${this.id}`)
      }
      this.$emit('click')
    }
  },
  computed: {
    getThumbUp () {
      return {
        idProp: this.isUp,
        url: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-block.svg',
        url1: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-grey.svg',
        count: this.upCount,
        label: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .customClass {
  width: 300px;
}
.content-item {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 23px 0 8px;
  display: flex;
  border-bottom: 1px solid #f5f5f5;
  .avater {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 16px;
  }
  .content-item-body {
    width: 100%;
    h5 {
      font-size: 14px;
      font-family: SFProText-Regular, SFProText;
      font-weight: 400;
      color: rgba(60, 60, 67, 0.6);
      line-height: 13px;
    }
    .content-item-body-header {
      display: flex;
      justify-content: space-between;
      .content-item-body-header-h2 {
        font-size: 16px;
        // font-family: SFProText-Semibold, SFProText;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        margin-bottom: 1px;
      }
      .tag {
        box-sizing: border-box;
        font-size:11px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(24,204,159,1);
        line-height: 20px;
        height:20px;
        background:rgba(236,253,249,1);
        border-radius:4px;
        box-sizing: border-box;
        display: inline-block;
        padding: 0 12px;
      }
    }
    .desc {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 24px;
      width: 79.2%;
      // text-overflow: ellipsis;
      // overflow: hidden;
      display: -webkit-box;
      // -webkit-line-clamp: 3;
      // -webkit-box-orient: vertical;
      margin-bottom: 10px;
    }
    .files {
      width: 100%;
      box-sizing: border-box;
      // height:92px;
      background:rgba(245,245,245,1);
      border-radius:5px;
      padding: 12px 13px;
      display: flex;
      img {
        width: 27px;
        height: 33px;
        margin-right: 17px;
      }
      div {
        display: flex;
        flex-direction: column;
        justify-content:space-between;
        a {
         text-decoration: none;
         .files-title {
            font-size:14px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:20px;
          }
        }
      }
    }
    .content-bottom {
      display: flex;
      height: 44px;
      justify-content: space-between;
      align-items: center;
      .content-bottom-left {
        display: flex;
        .delete {
          display: block;
          font-size:14px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(87,107,148,1);
          line-height:13px;
          margin-left: 16px;
        }
      }
      .menus {
        display: flex;
        justify-content: flex-start;
      }
    }
  }
}
</style>
